/*
src/services/audioStorage.js
*/

import { openDB } from 'idb';

const DB_NAME = '5dd_audio_safety';
const STORE_NAME = 'chunks';

export const audioDb = {
  async getDb() {
    return openDB(DB_NAME, 1, {
      upgrade(db) {
        if (!db.objectStoreNames.contains(STORE_NAME)) {
          db.createObjectStore(STORE_NAME, { keyPath: 'id', autoIncrement: true });
        }
      },
    });
  },

  async saveChunk(blob) {
    const db = await this.getDb();
    // Store with timestamp to ensure order
    await db.add(STORE_NAME, { blob, timestamp: Date.now() });
  },

  async getAllChunks() {
    const db = await this.getDb();
    return db.getAll(STORE_NAME);
  },

  async clearStorage() {
    const db = await this.getDb();
    await db.clear(STORE_NAME);
  },
  
  // Reassemble the blob from chunks
  async recoverBlob(mimeType = 'audio/webm') {
    const chunks = await this.getAllChunks();
    if (chunks.length === 0) return null;
    
    // Sort by ID to ensure correct audio sequence
    const sortedChunks = chunks.sort((a, b) => a.id - b.id);
    const blobs = sortedChunks.map(c => c.blob);
    
    return new Blob(blobs, { type: mimeType });
  }
};